import {
  boolean,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import {
  createSorterSchema,
  CUSTOMERS_SORT_KEYS
} from '@/features/shared/models'

export const CustomersSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(CUSTOMERS_SORT_KEYS),
  dcId: optional(number()),
  name: optional(string()), // 荷主名
  code: optional(string()), // 荷主コード
  enable: optional(boolean()) // 有効状態
})

export type CustomersSearch = InferOutput<typeof CustomersSearchSchema>
